import React from 'react';
import { components, ValueContainerProps } from 'react-select';
import { flatGroupGetIsGroup, FlatGroupOptionType } from './FlatGroupOptionType';

/**
 * Value container for GroupSelect, the parent ensures that the first
 * options are always groups (if all children are selected).
 */
export function GroupValueContainer({
    children,
    ...props
}: ValueContainerProps<FlatGroupOptionType, true>) {
    const summaryTags = props.getValue();

    // parent ensures that groups come first.
    const firstItem = summaryTags[0];
    const firstIsGroup = firstItem && flatGroupGetIsGroup(firstItem);

    // if it is a group (won't be here if it's not entirely selected)
    // and the rest of the selection is just the children)
    const hasMore =
        summaryTags.length > 1 &&
        !(firstIsGroup && firstItem.optionKeys?.length === summaryTags.length - 1);

    // requirement to style more and style groups differently
    const classNames = [hasMore ? 'has-more' : false].filter(Boolean);

    const summary = summaryTags?.length ? (
        <>
            <div className={`${classNames.join(' ')}`}>{firstItem.label}</div>
            {hasMore && <div className="ms-1">+ more</div>}
        </>
    ) : null;

    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && <span className="summary">{summary}</span>}
            {React.Children.map(children, (c) => (c as { props: any })?.props && c)}
        </components.ValueContainer>
    );
}
